/**
 * @exports
 * @class GalleryPopup
 */
import * as basicLightbox from 'basiclightbox';
import * as Flickity from 'flickity';
import * as imagesLoaded from 'imagesloaded';

import { get, getParameterByName, removeURLParameter } from '../../helpers/utilities';

import { popupTemplate } from './popup-template';

export class GalleryPopup {
    private root: Element;
    private data!: GalleryDataJSON;
    private popup!: basicLightbox.BasicLightBox;

    constructor(root: Element) {
        this.root       = root;

        // Get our data object
        const dataScript = get('.js-application-gallery__data', this.root) as HTMLScriptElement;
        if(!dataScript) return;

        // Grab our JSON data
        this.data = JSON.parse( dataScript.innerHTML ) as GalleryDataJSON;

        // Create our lightbox
        this.popup = basicLightbox.create(popupTemplate(this.data), {
            onShow:  (instance: basicLightbox.BasicLightBox) => this.onShow(instance),
            onClose: ({}) => this.onClose(),
        });

        // Bind our events
        this.bindEvents();
    }


    /**
     * Get's fired when the lightbox is shown, basically initiates our JS for the contents.
     *
     * @param instance The lightbox instance
     */
    private onShow(instance: basicLightbox.BasicLightBox): boolean {

        // Initialise the slider.
        const sliderElem = get('.js-application-gallery__slider', instance.element());
        if(sliderElem) {

            // Create the slider
            const slider = new Flickity(sliderElem, {
                wrapAround: true,
                cellAlign: 'left',
                pageDots: false,
                setGallerySize: false
            });

            imagesLoaded(sliderElem).on('progress', () => {
                slider.resize();
            });
        }

        // Enable the close button
        const closeBtn = get('.js-popup-gallery__close', this.popup.element());
        if(closeBtn) {
            closeBtn.addEventListener('click', () => {
                this.popup.close();
            });
        }

        // Set the currently active item
        window.app.modules.application_galleries.setCurrentPopup(this);


        return true;
    }


    /**
     * Get's fired when the lightbox is closed.
     * 
     * @param instance The lightbox instance
     */
    private onClose(): boolean {

        // Remove the item parameter
        if(history.pushState) {
            history.pushState('', '', removeURLParameter('item', this.data.permalink));
        }

        return true;
    }


    /**
     * Binds the events for this class
     * 
     * @private
     * @exports void
     */
    private bindEvents(): void {

        // Open on click
        const boxBtn = get('.js-application-gallery__btn', this.root);
        if(boxBtn) {
            boxBtn.addEventListener('click', () => {
                this.open();

                if(history.pushState) {
                    history.pushState('', '', this.data.permalink);
                }
            });
        }

        // Open on load
        const currentItem = parseInt(getParameterByName('item') as string, 10);
        if(currentItem === this.data.id) {
            this.open();
        }
    }


    /**
     * Opens the popup
     * 
     * @public
     * @returns void
     */
    public open(): void {
        this.popup.show();
    }


    /**
     * Opens the popup
     * 
     * @public
     * @returns void
     */
    public close(): void {
        this.popup.close();
    }
}
